import { createCookieForHours } from '../components/common/Cookie';

export const getAffiliatePayload = () => {
  console.log(
    'Affiliate logs: [getAffiliatePayload] STEP 1 - called, url:',
    typeof window !== 'undefined' ? window.location?.href : 'no-window'
  );
  if (typeof window === 'undefined' || !window.location) {
    console.log(
      'Affiliate logs: [getAffiliatePayload] STEP 1a - no window/location -> return null'
    );
    return null;
  }
  const params = new URLSearchParams(window.location.search);

  console.log('Affiliate logs: [getAffiliatePayload] STEP 2 - params:', params.toString());
  const utmMedium = params.get('utm_medium');
  console.log('Affiliate logs: [getAffiliatePayload] STEP 3 - utmMedium:', utmMedium);

  // Only proceed if channel is affiliate or creator
  if (utmMedium !== 'affiliate' && utmMedium !== 'creator') {
    console.log(
      'Affiliate logs: [getAffiliatePayload] STEP 3a - utm_medium not affiliate/creator -> return null'
    );
    return null;
  }

  // params.delete('utm_medium');
  // console.log(
  //   'Affiliate logs: [getAffiliatePayload] STEP 4 - utm_medium removed from params:',
  //   params.toString()
  // );

  // Build correct URL with ?
  // const newUrl = `${window.location.pathname}?${params.toString()}`;
  // console.log('Affiliate logs: [getAffiliatePayload] STEP 5 - newUrl:', newUrl);

  // Update URL without reload
  // window.history.replaceState({}, document.title, newUrl);
  const payload = {
    attributed_affiliate_name: params.get('utm_source'),
    attributed_affiliate_id: params.get('pid'),
    attributed_affiliate_campaign_id: params.get('offer_id'),
    attributed_affiliate_click_id: params.get('clickid'),
    attributed_affiliate_sub_id: 'NA',
    attributed_affiliate_additional_publisher_info: params.get('utm_term'),
    attributed_affiliate_campaign_medium: utmMedium,
    attributed_affiliate_campaign_name: params.get('utm_campaign')
  };
  console.log('Affiliate logs: [getAffiliatePayload] STEP 6 - built payload:', payload);
  return payload;
};

export const getAffiliateCookie = () => {
  console.log('Affiliate logs: [getAffiliateCookie] STEP 1 - called');
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    console.log('Affiliate logs: [getAffiliateCookie] STEP 1a - no window/document -> return null');
    return null;
  }
  const cookie = document.cookie.split('; ').find(c => c.startsWith('affiliate_tracking='));
  const params = new URLSearchParams(window?.location?.search);
  console.log(
    'Affiliate logs: [getAffiliateCookie] STEP 2 - raw cookie:',
    cookie,
    'url params:',
    params.toString()
  );

  const utmMedium = params.get('utm_medium');
  console.log('Affiliate logs: [getAffiliateCookie] STEP 3 - utmMedium:', utmMedium);
  if (utmMedium?.length > 0 && utmMedium !== 'affiliate' && utmMedium !== 'creator') {
    console.log(
      'Affiliate logs: [getAffiliateCookie] STEP 3a - utm_medium present but not affiliate/creator -> return null'
    );
    return null;
  }
  if (!cookie) {
    console.log(
      'Affiliate logs: [getAffiliateCookie] STEP 3b - no affiliate_tracking cookie -> return null'
    );
    return null;
  }

  try {
    const parsed = JSON.parse(decodeURIComponent(cookie.split('=')[1]));
    console.log('Affiliate logs: [getAffiliateCookie] STEP 4 - parsed cookie:', parsed);
    return parsed;
  } catch (err) {
    console.log('Affiliate logs: [getAffiliateCookie] STEP 4a - parse error -> return null', err);
    return null;
  }
};

export const setAffiliateCookie = (affiliateFeatureConfig = {}, creatorprogramconfig = {}) => {
  console.log(
    'Affiliate logs: [setAffiliateCookie] STEP 1 - called with affiliateFeatureConfig:',
    affiliateFeatureConfig,
    'creatorprogramconfig:',
    creatorprogramconfig
  );
  if (typeof window !== 'undefined' && window.location) {
    const utmMedium = new URLSearchParams(window.location.search).get('utm_medium');
    console.log('Affiliate logs: [setAffiliateCookie] STEP 2 - url utm_medium:', utmMedium);
    if (utmMedium && utmMedium !== 'affiliate' && utmMedium !== 'creator') {
      console.log(
        'Affiliate logs: [setAffiliateCookie] STEP 2a - utm_medium is neither affiliate nor creator -> erase cookie'
      );
      createCookieForHours('affiliate_tracking', '', -1);
      return;
    }
  }

  const newData = getAffiliatePayload();
  console.log('Affiliate logs: [setAffiliateCookie] STEP 3 - newData from payload:', newData);
  if (newData) {
    const oldData = getAffiliateCookie('affiliate_tracking');
    console.log('Affiliate logs: [setAffiliateCookie] STEP 4 - oldData from cookie:', oldData);
    const medium = newData.attributed_affiliate_campaign_medium;
    const attributionWindow =
      medium === 'creator'
        ? creatorprogramconfig?.creatorAttributionWindow || 0
        : affiliateFeatureConfig?.attributionWindow || 24;
    console.log(
      'Affiliate logs: [setAffiliateCookie] STEP 5 - medium:',
      medium,
      'attributionWindow(hours):',
      attributionWindow
    );
    if (!oldData) {
      console.log(
        'Affiliate logs: [setAffiliateCookie] STEP 6a - no existing cookie -> writing first-time cookie:',
        newData
      );
      // First affiliate/creator click
      createCookieForHours(
        'affiliate_tracking',
        encodeURIComponent(JSON.stringify(newData)),
        attributionWindow
      );
    } else if (oldData.attributed_affiliate_id !== newData.attributed_affiliate_id) {
      // Different affiliate/creator → overwrite
      console.log(
        'Affiliate logs: [setAffiliateCookie] STEP 6b - different attributed_affiliate_id -> overwriting cookie:',
        newData
      );
      createCookieForHours(
        'affiliate_tracking',
        encodeURIComponent(JSON.stringify(newData)),
        attributionWindow
      );
    } else {
      console.log(
        'Affiliate logs: [setAffiliateCookie] STEP 6c - same attributed_affiliate_id -> keep existing cookie'
      );
    }
    // Same affiliate/creator → keep old cookie
  } else {
    console.log('Affiliate logs: [setAffiliateCookie] STEP 3a - no newData -> nothing to write');
  }
};
